import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions } from '@amplement/backend-connector';

import useWhyDidYouUpdate from 'hooks/useWhyDidYouUpdate';
import Button from 'components/Shared/Common/Button';
import { RECORDER_STATUS } from 'components/Shared/Recorder/constants';

const ExitButton = (props) => {
    const {
        onClick,
        onStopRecording,
        recorderState,
        isEnabled,
        handleChangeStatus,
        ...btnProps
    } = props;

    const handleClick = useCallback(() => {
        if (recorderState === RECORDER_STATUS.RECORDING) {
            onStopRecording();
            handleChangeStatus(RECORDER_STATUS.STOPPED);
        }
        onClick();
    }, [onClick, onStopRecording]);

    useWhyDidYouUpdate('component:ExitButton', props);

    return (
        <Button
            iconName="PhoneOff"
            color="error"
            onClick={handleClick}
            {...btnProps}
        />
    );
}

ExitButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    recorderState: PropTypes.oneOf(Object.values(RECORDER_STATUS)),
    onStopRecording: PropTypes.func,
    handleChangeStatus: PropTypes.func,
}

ExitButton.defaultProps = {
    onStopRecording: () => {},
    handleChangeStatus: () => {},
    recorderState: RECORDER_STATUS.STOPPED,
};

const Component = memo(ExitButton);

export default Component;

const mapDispatchToProps = (dispatch, { _room }) => ({
    onClick: () => dispatch(actions.rooms.requestPostRoomLeave(_room)),
});

export const container = connect(null, mapDispatchToProps)(Component);
